import React from 'react'
import { useFormContext } from 'react-hook-form'

import { type InputValues } from '../utils'

import { useSurvey } from './useSurvey'

export const useSampleSize = () => {
  const { watch } = useFormContext<InputValues>()
  const count = watch('surveyFilter.count')

  const survey = useSurvey()

  return React.useMemo(
    () => count ?? survey?.numberOfTotalAnswers ?? NaN,
    [count, survey?.numberOfTotalAnswers],
  )
}
